// Single source of truth for the FAQ page: renders the accordion (FAQ.tsx) and
// the FAQPage JSON-LD baked into static HTML at prerender time (routeMeta.ts).

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: "How accurate are these statistics?",
    answer:
      "Our calculator uses real government data from the U.S. Census Bureau, CDC NHANES surveys, and Pew Research Center. The statistics reflect population-level trends but individual results may vary significantly based on personal factors, location, and social circles not captured in the data.",
  },
  {
    question: "Why are some results so low?",
    answer:
      "The calculator multiplies probabilities for each preference, which can result in very low percentages when multiple selective criteria are combined. This reflects the mathematical reality that having many specific preferences significantly reduces the pool of compatible individuals.",
  },
  {
    question: 'What does "SMV" mean in the results?',
    answer:
      "SMV stands for \"Sexual Market Value\" - a concept from relationship psychology referring to one's attractiveness and desirability as a romantic partner. The calculator suggests improving SMV when probabilities are very low, meaning focus on self-improvement in areas like fitness, career, social skills, and personal development.",
  },
  {
    question: "Does location matter for these calculations?",
    answer:
      "Our calculators use national U.S. averages, but we now publish state-level estimates showing how many women aged 18-44 live in each state along with education and marriage statistics. Demographics vary significantly by region, so check the Statistics by State section for your area.",
  },
  {
    question: "How often is the data updated?",
    answer:
      "We update our statistical data annually when new Census and survey data becomes available. The most recent data incorporates 2022-2023 survey results from the U.S. Census Bureau's American Community Survey and Current Population Survey.",
  },
  {
    question: "Can I share my results?",
    answer:
      "Yes! After completing a calculation, your inputs are encoded in the page URL - use the Copy Link button to share the exact result, or download a shareable result card image with your probability and Reality Score.",
  },
  {
    question: "What if I get a result under 1%?",
    answer:
      "Results under 1% indicate extremely selective preferences. Consider whether all criteria are truly necessary, focus on self-improvement to increase your own attractiveness, or expand your social circles to increase your chances of meeting compatible individuals. Remember that statistics don't determine individual outcomes.",
  },
  {
    question: "Is this tool biased or inappropriate?",
    answer:
      "The calculator presents statistical reality based on government demographic data without editorial commentary. It's designed to provide objective probability calculations based on your stated preferences. The statistical methodology and data sources are neutral and professionally maintained.",
  },
  {
    question: "How does educational level affect compatibility results?",
    answer:
      "Educational preferences can significantly impact compatibility probabilities. Higher education preferences (Bachelor's or Graduate degrees) typically reduce the pool, especially when combined with age and race preferences, since educational attainment varies by demographic group and age cohort.",
  },
  {
    question: "Is there a version for evaluating standards for men?",
    answer:
      "Yes. The Male Partner Calculator applies the same multiplicative probability model to US male demographic data, including the most commonly discussed filters: minimum height, minimum income, education, and employment status.",
  },
  {
    question: "How should I interpret very high results (over 20%)?",
    answer:
      "Results over 20% suggest relatively achievable dating goals. Focus on meeting more people through social activities, dating apps, and expanding your social network. High statistical compatibility doesn't guarantee personal chemistry, so volume and variety in dating opportunities remain important.",
  },
];
